export const textKeysNewQDMobileToolbar = ['NEW_QUICK_DEPOSIT_TOOLBAR_BUTTON_TEXT'];

export const textKeysNewQDAmountScreenHeader = ['NEW_QUICK_DEPOSIT_AMOUNT_SCREEN_HEADING'];

export const textKeysNewQDMethodCollapse = [
	'NEW_QUICK_DEPOSIT_CHANGE_PAYMENT_METHOD_LIST',
	'NEW_QUICK_DEPOSIT_MORE_METHODS'
];

export const textKeysNewQDAmountContainer = ['NEW_QUICK_DEPOSIT_DEPOSIT_BUTTON', 'NEW_QUICK_DEPOSIT_ENTER_AMOUNT'];
